<form [formGroup]="formGroup" (submit)="isFormValid()" fxLayout="column" fxLayoutAlign="center center">

  <mat-toolbar fxLayout="row">
    <button mat-icon-button [matTooltip]="'LABEL_CLOSE' | translate" (click)="confirmChanges()" type="button">
      <mat-icon svgIcon="close"></mat-icon>
    </button>
    <span fxFlex></span>
    <span class="mat-detail-header text-align-center">
      {{ detail?.id ? ('LABEL_EDIT_TYPE' | translate : { type: 'LABEL_DEVICE' | translate }) : ('LABEL_ADD_NEW' | translate : { type: 'LABEL_DEVICE' | translate }) }}
    </span>
    <span fxFlex></span>
    <button mat-icon-button [matTooltip]="'LABEL_SAVE' | translate" type="submit" [disabled]="disableSaveBtn()">
      <mat-icon svgIcon="check"></mat-icon>
    </button>
  </mat-toolbar>

  <div fxLayout="column" class="padding-25" fxFlexFill>
    <!-- code -->
    <!-- <div fxLayout>
      <mat-form-field>
        <input
          #code
          matInput
          required
          autocomplete="off" 
          formControlName="code" 
          [placeholder]="'LABEL_CODE' | translate"
          >

        <mat-error *ngIf="formGroup.get('code').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>  

        <mat-error *ngIf="formGroup.get('code').hasError('maxlength')">
          {{ 'MSG_MAXLENGTH' | translate: {length: '8'} }}
        </mat-error>  
                
        <mat-error *ngIf="formGroup.get('code').hasError('pattern')">
          {{ 'MSG_NO_SPECIAL_CHARS' | translate }}
        </mat-error> 
      </mat-form-field>
    </div> -->

    <!-- terminal_id -->
    <div fxLayout>
      <mat-form-field>
        <input 
          matInput
          required
          #terminal_id 
          autocomplete="off" 
          formControlName="terminal_id" 
          [placeholder]="'LABEL_TERMINAL_ID' | translate"
          >
          
        <mat-error *ngIf="formGroup.get('terminal_id').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>  

        <mat-error *ngIf="formGroup.get('terminal_id').hasError('maxlength')">
          {{ 'MSG_MAXLENGTH' | translate: {length: '10'} }}
        </mat-error>  
                
        <mat-error *ngIf="formGroup.get('terminal_id').hasError('pattern')">
          {{ 'MSG_NO_SPECIAL_CHARS' | translate }}
        </mat-error> 
      </mat-form-field>
    </div>

    <!-- description -->
    <div fxLayout>
      <mat-form-field>
        <input 
          matInput
          required
          #description 
          autocomplete="off" 
          formControlName="description" 
          [placeholder]="'LABEL_DESCRIPTION' | translate"
          >
          
        <mat-error *ngIf="formGroup.get('description').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>  

        <mat-error *ngIf="formGroup.get('description').hasError('maxlength')">
          {{ 'MSG_MAXLENGTH' | translate: {length: '20'} }}
        </mat-error>  
                
        <mat-error *ngIf="formGroup.get('description').hasError('pattern')">
          {{ 'MSG_NO_SPECIAL_CHARS' | translate }}
        </mat-error> 
      </mat-form-field>
    </div>

    <!-- branch -->
    <esc-branch-dropdown
      class="width-100" 
      [formWrapperFlex]="'none'"
      [wrapperLayoutAlign]="'start center'"
      (optionSelected)="branchSelected($event)"
      [previousData]="detail"
      [requiredError]="branchRequired"
      [disabled]="isDisabled"
      [isRequired]="true"
      >
    </esc-branch-dropdown>
     
    <!-- device_location -->
    <mat-form-field>
      <mat-label>
        {{ 'LABEL_LOCATION' | translate }}
      </mat-label>

      <mat-select id="id_device_location_dropdown" formControlName="device_location" [compareWith]="compareWithFunc" required>
        <mat-option [id]="'id_device_location_data_' + (i+1)" *ngFor="let opt of locations; let i = index" [value]="opt">
          {{opt.code}} - {{opt.description}}
        </mat-option>
      </mat-select>

      <mat-error *ngIf="formGroup.get('device_location').hasError('required')">
        {{ 'MSG_FIELD_REQUIRED' | translate }}
      </mat-error>    
    </mat-form-field>

    <!-- imei -->
    <div fxLayout>
      <mat-form-field>
        <input 
          matInput
          required
          #imei 
          autocomplete="off" 
          formControlName="imei" 
          [placeholder]="'LABEL_IMEI' | translate"
          >
          
        <mat-error *ngIf="formGroup.get('imei').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>  

        <mat-error *ngIf="formGroup.get('imei').hasError('maxlength')">
          {{ 'MSG_MAXLENGTH' | translate: {length: '15'} }}
        </mat-error>  
                
        <mat-error *ngIf="formGroup.get('imei').hasError('pattern')">
          {{ 'MSG_NUMBERS_ONLY' | translate }}
        </mat-error> 
      </mat-form-field>
    </div>

    <!-- device type -->
    <div fxLayout>
      <mat-form-field>
        <input 
          matInput
          required
          #imei 
          autocomplete="off" 
          formControlName="device_type" 
          [placeholder]="'LABEL_DEVICE_TYPE' | translate"
          >
          
        <mat-error *ngIf="formGroup.get('device_type').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>  

        <mat-error *ngIf="formGroup.get('device_type').hasError('maxlength')">
          {{ 'MSG_MAXLENGTH' | translate: {length: '15'} }}
        </mat-error>  
      </mat-form-field>
    </div>

    <!-- terminal_is_registered -->
    <mat-checkbox formControlName="terminal_is_registered">{{'LABEL_REGISTERED' | translate}}</mat-checkbox>

    <!-- status / is_active -->
    <mat-checkbox formControlName="status">{{'LABEL_ACTIVE' | translate}}</mat-checkbox>

  </div>
</form>